import React from "react";
import "./Offers.css";
import exclusive_image from "../Assets/exclusive_image.png";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

const Offers = () => {
  return (
    // The entire component is now a clickable link
    <Link to="/combos" className="offers-link">
      <div className="offers">
        <div className="offers-left">
          <h1>Weekend</h1>
          <h2>Combo Specials</h2>
          <p>SAVORY DEALS ON YOUR FAVORITES</p>
          <div className="offers-button">
            <span>View Combos</span>
            <FiChevronRight size={22} />
          </div>
        </div>
        <div className="offers-right">
          <img src={exclusive_image} alt="Exclusive Offers" />
        </div>
      </div>
    </Link>
  );
};

export default Offers;